/* eslint eqeqeq: 'off', curly: 'error', @typescript-eslint/no-unused-vars: 'off', react-hooks/exhaustive-deps: 'off', array-callback-return: 'off', no-eval: 'off', jsx-a11y/alt-text: 'off', jsx-a11y/anchor-is-valid: 'off' */
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as API from '../../http/api';
import DataTable from 'react-data-table-component';
import { ThemeProvider } from '@mui/material/styles';
import { theme, customStyles2 } from '../../util/TableStyles';
import { noDataComponent, rolesType, menuType, categoryMenu } from '../../util/DataObject';
import { Typography, Tabs, Tab, Box, Tooltip, IconButton, List, ListItem, Button, Grid, TextField, MenuItem } from '@mui/material';
import { Delete, Edit, Check, Close, Engineering, InfoOutlined } from '@mui/icons-material';
import { useDialog, Card } from '@albo-ui/core'

import SpaceTxTracking from '../modals/SpaceTxTracking'
import { openlightbox } from '../../util/Functions';
import { useConfirm } from '../modals/confirm';
import FeatureInext from '../modals/feature-inext/FeatureInext';
import { JsonToCsv } from '../../util/JsonToCsv';

const InextManagerFeatures = (props) => {
	const history = useHistory();
	const [data, setData] = useState([]);
	const [updateData, setUpdateData] = useState(null);
	const [filterData, setFilterData] = useState([]);
	const [tabActive, setTabActive] = useState('menu');
	const [columns, setColumns] = useState([]);
	const [divideRoles, setDivideRoles] = useState([]);
	const [search, setSearch] = useState({key: '', menu: ''});
	const title = `Crear nuevo ${tabActive}`
	const titleUpdate = `Actualizar ${tabActive}`
	const dialogProps = useDialog()

	const [tabs] = useState([
		{ key: 'menu', title: 'Menu' },
		{ key: 'widget', title: 'Widgets' },
		{ key: 'intent', title: 'Intents' }
	]);

	const { DialogConfirm, confirm: confirmUpdateStatus } = useConfirm(
		`Eliminar ${tabActive}`,
		'¿Estás seguro que deseas realizar este cambio? Recuerda que al eliminarlo podrás afectar las funciones de otros roles'
	);

	const hasAction = (action) => {
		return props.widgets[0].config?.actions?.indexOf(action) > -1;
	};

	const changeTab = (tab: string) => {
		setTabActive(tab);
		createColumns(tab)
	};

	function findActiveTab(item) {
		return item.key === tabActive;
	};

	const searchValue = async (type, e) => {
		let old = data[tabActive];
		let value = e.target.value
		setSearch({...search, [type]: value});

		let newList = [];
		let validate = (type === 'key' ? search.menu : search.key).length > 0
		let check = value ? true : false

		function addItem (arr){
			for (let i = 0; i < old.length; i++) {
				var test = []
				let val1 = old[i][type];
				let val2 = val1?.toLowerCase()?.indexOf(value.toLowerCase()) > -1;
				let val3 = val1?.toLowerCase()?.indexOf(search.key.toLowerCase()) > -1;
				let val4 = old[i].type === value;
				let val5 = old[i].type === search.menu;
				let valuesResult = [val1, val2, val3, val4, val5]

				for (let j = 0; j < arr.length; j++) {
					if(!valuesResult[arr[j]]){
						test.push(arr[j])
					}
				}
				
				if (test.length === 0) {
					newList.push(old[i]);
				}
			}
			setFilterData(JSON.parse(JSON.stringify({...filterData, [tabActive]: newList})));
		}

		switch (type+'|'+validate+'|'+check) {
			case 'key|true|true':
				addItem([0,1,4])
				break;
			case 'key|false|true':
			case 'name|false|true':
			case 'description|false|true':
				addItem([0,1])
				break;
			case 'key|true|false':
				addItem([4])
				break;
			case 'menu|false|true':
				addItem([3])
				break;
			case 'menu|true|true':
				addItem([3,0,2])					
				break;
			case 'menu|true|false':
				addItem([0,2])
				break;
			case 'key|false|false':
			case 'menu|false|false':
			case 'name|false|false':
			case 'description|false|false':
				setFilterData(JSON.parse(JSON.stringify(data)));
				break;
			default:
				break;
		}
	}

    const inputSearch = (name, input, array?) => {
        return <Grid item  width={'19%'}>
            {!array ?
                <TextField label={name} onChange={searchValue.bind(this, input)} color='secondary' size='small' fullWidth/>
                :
                <TextField label={name} value={search.menu || -1} defaultValue={-1} onChange={searchValue.bind(this, 'menu')} select size='small' fullWidth color='secondary'>
                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                    <MenuItem value=''>Todos</MenuItem>
                    {array?.map((item, index) => (
                        <MenuItem value={item.value} key={`menu-${index}`}>{item.label}</MenuItem>
                    ))}
                </TextField>
            }
        </Grid>
    }

	const addRegister = async (tab) => {
		dialogProps.openDialog()
	}
	const onCloseDialog = () => {
        dialogProps.onClose()
		setUpdateData(null)
	}
	const onCreateFeature = async (item: any, tab: string, update: false) => {
		dialogProps.onClose()
		update ? updateFeature(item, tab) : addFeature(item, tab)
    }
	const updateRegister = async (item, tab) => {
		setUpdateData({data: item, tab: tab})
		dialogProps.openDialog()
	}

	const addFeature = async (data, tab) => {
        props.changeLoader(true);        

		let response = await API.service( `add${tab.charAt(0).toUpperCase() + tab.slice(1)}`, data, props.pos, props.changeAlert, props.changeLoader, history );
		if(response.data.data.response == "OK"){
           	await reloadData()
			props.changeAlert(true, "success", `El ${tab} ha sido creado con éxito`);
		} else {
			let detail = response.data.data.message;
			props.changeAlert(true, "error", `Error al crear ${tab}. ` + detail);
        }
		props.changeLoader(false);
    };

	const updateFeature = async (item, tab) => {
		props.changeLoader(true);

		let response = await API.service( `update${tab.charAt(0).toUpperCase() + tab.slice(1)}s`, item, props.pos, props.changeAlert, props.changeLoader, history );
		if (response.data.data.response == "OK") {
			setUpdateData(null)
			await reloadData()
			props.changeAlert(true, "success", `El ${tab} ha sido actualizado con éxito`);
		} else {
			let detail = response.data.data.message;
			props.changeAlert(true, "error", `Error al actualizar ${tab}. ` + detail);
		}
		props.changeLoader(false);
		return;
	}

	const deleteItem = async (item, tab) => {
		let isConfirm = await confirmUpdateStatus()
		if (isConfirm) {
			props.changeLoader(true);
		
			let response = await API.service( `delete${tab.charAt(0).toUpperCase() + tab.slice(1)}`, item.uuid, props.pos, props.changeAlert, props.changeLoader, history );
			if (response.status === 200) {
			  if (response.data.data.response == "OK") {
				await reloadData()
				props.changeAlert(true, "success", `El ${tab} ha sido eliminado con éxito`);
			  } else {
				let detail = response.data.data.message;
				props.changeAlert(true, "error", `Error al eliminar ${tab}. ` + detail);
			  }
			}
			props.changeLoader(false);
		}
		return;
	};

	const reloadData = async () => {
        props.changeLoader(true);
        let response = await API.service('inextManagerFeatures', {}, props.pos, props.changeAlert, props.changeLoader, history);
        if (response.status == 200) {
            if (response.data.data.response == 'OK') {
				props.changeWidgets(JSON.parse(JSON.stringify(response.data.data.widget)));
				props.changeLoader(false);
            }
        } else {
			let detail = response.data.data.message;
			props.changeAlert(true, "error", `Error al consultar lista` + detail);
			props.changeLoader(false);
        }
    }

	const viewInfo = (item) => {
        let contentModal = {
          title: `Detalle - ${item.key}`,
          content: item,
        }

        const as = <SpaceTxTracking 
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          contentModal={contentModal}
          key='spaceTxTracking' 
        />
        openlightbox(as);
	}

	const divideArr = () => {
		const size = Math.ceil(rolesType.length / 3);
		let halfs = [];
		var i = 0;
		while (i < rolesType.length) {
            halfs.push(rolesType.slice(i, i += size));
        }
		setDivideRoles(halfs)
	}

	const showRoles = ({ data }) => {
		const roles = [];
		rolesType.map((item) =>
			roles.push({
				selector: (row) => row.roles?.indexOf(item.key) > -1 ? <Check color='success' /> : <Close color='error' />, name: item.value, width: 'auto', wrap: true, sortable: true,
			})
		);

		return (
			<Box ml={8}>
				<DataTable
					columns={roles}
					data={[data]}
					customStyles={customStyles2}
					noDataComponent={noDataComponent}
					dense
				/>
			</Box>
		);
	};

	const resumeActions = (row) => {
		let result = []
		Object.keys(row).filter((item) => {
			if(row[item]['actions']?.length > 0){
				result = result.concat(row[item]['actions'])
			}
		})

		function removeDuplicates(arr) {
			let unique = arr.reduce(function (acc, curr) {
				if (!acc.includes(curr)){
					acc.push(curr)
				}
				return acc;
			}, []);
			return unique.length === 0 ? '---' : unique.join(', ');
		}

		return removeDuplicates(result)
	}

	
	const createColumns = (tab) => {
		const list = [];
		list.push(
			{ selector: (row) => row.key, name: 'Key', width: '25%', wrap: true, sortable: true },
		);
		switch (tab) {
			case 'menu':
				list.push(
					{ selector: (row) => row.name ? row.name : 'N/A', name: 'Nombre', width: '30%', wrap: true, sortable: true },
					{ selector: (row) => row.type === 'principal' ? 'Principal' : 'Secundario', name: 'Menú', width: '15%', wrap: true, sortable: true }
				);
				break;
			case 'widget':
				list.push(
					{ selector: (row) => row['description'] ? row['description'] : 'N/A', name: 'Descripción', width: '20%', wrap: true, sortable: true },
					{ selector: (row) => row['config'] ? resumeActions(row['config']) : 'N/A', name: 'Acciones', width: '25%', wrap: true, sortable: true }
				);
				break;
			case 'intent':
				list.push(
					{ selector: (row) => row['description'] ? row['description'] : 'N/A', name: 'Descripción', width: '30%', wrap: true, sortable: true },
					{ selector: (row) => row['step'] ? 'Si' : '---', name: 'Steps', width: '10%', wrap: true, sortable: true }
				);
				break;
			default:
				break;
		}

		list.push(
			{ selector: (row) => row.roles?.length > 0 ? 'Sí' : 'No', name: 'En Uso', width: '10%', wrap: true, sortable: true, center: true },
			{
				cell: (item) => {
					return (
						<>
							{hasAction("update") && <Tooltip title='Editar'><IconButton onClick={updateRegister.bind(this, item, tab)}><Edit /></IconButton></Tooltip>}
							{hasAction("delete") && <Tooltip title='Eliminar'><IconButton onClick={deleteItem.bind(this, item, tab)}><Delete /></IconButton></Tooltip>}
							{hasAction("detail") && <Tooltip title='Detalle'><IconButton onClick={viewInfo.bind(this, item)}><InfoOutlined /></IconButton></Tooltip>}
						</>
					)
				},
				name: 'Acciones', width: '15%', wrap: true, sortable: true, center: true
			}
		);

		setColumns(list)
	}

	useEffect(() => {
		if (props.content) {
			setData(props.content);
			setFilterData(props.content);
			createColumns(tabActive)
			divideArr()
		}
	}, [props.content]);


	const downloadReport = async () => {
			props.changeLoader(true);

			let columns = [];

			switch (tabActive) {
				case "menu":
					columns.push(
						{ header: "Menu", key: "name", width: 40, style: {alignment: {vertical: "middle"}} },
						{ header: "iNext ID", key: "key", width: 30, style: {alignment: {vertical: "middle"}} },
						{ header: "Tipo", key: "type", width: 15, style: {alignment: {vertical: "middle"}} },
					)
					break;
				case "intent":
					columns.push(
						{ header: "#", key: "num", width: 5, style: {alignment: {vertical: "middle"}} },
						{ header: "Intent", key: "description", width: 40, style: {alignment: {vertical: "middle"}} },
						{ header: "iNext ID", key: "key", width: 30, style: {alignment: {vertical: "middle"}} },
					)
					break;
				case "widget":
					columns.push(
						{ header: "N°", key: "num", width: 5, style: {alignment: {vertical: "middle", horizontal: "center"}} },
						{ header: "Widget", key: "description", width: 40, style: {alignment: {vertical: "middle"}} },
						{ header: "iNext ID", key: "key", width: 30, style: {alignment: {vertical: "middle"}} },
					)
					break;
			};

			rolesType.map((role) => {
				columns.push({ header: role.value, key: role.key, note: "Hola", style: {alignment: {horizontal: "center", vertical: "middle"}} })
			})

            let newList = data[tabActive].map((item, index) => {
				item['num'] = index + 1
				if(item['roles']){
					rolesType.map((role) => {
						item['roles'].includes(role.key) ? item[role.key] = "Si" : item[role.key] = "No"
					})
				}
				return item
            });

            let fileName = `reporte-${tabActive}`

			let specialCells = {
				iconRef: `D2:Q${newList.length + 1}`,
				rules: [
					{
						type: 'expression',
						formulae: ['D2="Si"'],
						priority: 0,
						style: { font: { color: { argb: '38761D' }, bold: true }}
					},
					{
						type: 'expression',
						formulae: ['D2="No"'],
						priority: 0,
						style: { font: { color: { argb: '1D6976' }, bold: true }}
					},
					// {
					//     type: 'iconSet',
					//     showValue: false,
					//     iconSet: "3Symbols2",
					//     priority: 1,
					//     cfvo: [
					//         {type: "num", value: 1}
					//     ]
					// },
				]
			}

            JsonToCsv(newList, columns, fileName, specialCells)
            props.changeLoader(false);
    }

	return (
		<>
		<DialogConfirm />
		<Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{borderColor: "#EDF0F4"}}>
			<Box>
				<Typography variant='h2' style={{ display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem' }} fontWeight={600}>
					<Engineering sx={{ marginRight: 1 }} /> Administrador Features iNext
				</Typography>
				<Box mb={4} ml={4}sx={{ fontStyle: 'italic', fontWeight: '500 !important' }}>
					Configuración de Funcionalidades
				</Box>
			</Box>
			<Grid item >
				<Button variant="contained" size='small' onClick={downloadReport.bind(this)}>Descargar {tabActive}</Button>
			</Grid>
			

			<Grid container item xs={12} spacing={2} mb={1} justifyContent={'end'}>
				{inputSearch('Key', 'key')}
				{tabActive === 'menu' && inputSearch('Nombre', 'name')}
				{tabActive !== 'menu' && inputSearch('Descripción', 'description')}
				{tabActive === 'menu' && inputSearch('Menu', null, menuType)}
				{hasAction('create') && 
					<Grid item >
						<Button variant="contained" size='small' onClick={addRegister.bind(this, tabActive)}>Crear {tabActive} </Button>
					</Grid>
				}
				
			</Grid>

			<Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2}>
				<Tabs value={tabs.findIndex(findActiveTab)}>
					{tabs.map((item, index) => {
						return (
							<Tab key={index} label={item.title} onClick={changeTab.bind(this, item.key)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 18,}}/>
						);
					})}
				</Tabs>
			</Box>
			
			<ThemeProvider theme={theme}>
				<DataTable
					columns={columns}
					data={filterData[tabActive]}
					customStyles={customStyles2}
					noDataComponent={noDataComponent}
					expandableRows
					expandableRowsComponent={showRoles}
					highlightOnHover
					pagination
					dense
				/>
			</ThemeProvider>
			{divideRoles.length > 0 &&
				<Box sx={{bgcolor: 'background.paper'}}>
					<hr/>
					<Typography>Leyenda</Typography>
					<List>
						<Grid container spacing={2}>
							<Grid item xs={4}>
								{divideRoles[0].map((item, key) => {
									return <ListItem key={key}>{item.value} {'-->'} {item.label}</ListItem>
								})}
							</Grid>
							<Grid item xs={4}>
								{divideRoles[1].map((item, key) => {
									return <ListItem key={key}>{item.value} {'-->'} {item.label}</ListItem>
								})}
							</Grid>
							<Grid item xs={4}>
								{divideRoles[2].map((item, key) => {
									return <ListItem key={key}>{item.value} {'-->'} {item.label}</ListItem>
								})}
							</Grid>
						</Grid>
					</List>
				</Box>
			}
		</Card>
		<FeatureInext 
			title={updateData ? titleUpdate : title} 
			open={dialogProps.open} 
			onClose={onCloseDialog} 
			onConfirm={onCreateFeature.bind(this)} 
			changeAlert={props.changeAlert}
			tab={tabActive}
			roles={rolesType}
			menu={menuType}
			categoryMenu={categoryMenu}
			data={updateData}
        />
		</>
	);
};

export default InextManagerFeatures;
